import { SelectMenu } from '@hakimo-ui/hakimo/ui-elements';
import {
  ProfileTypeFilterValue,
  ProfileTypeFilterOption,
  PROFILE_TYPE_FILTER_OPTIONS,
} from '../types';

interface Props {
  value: ProfileTypeFilterValue;
  onChange: (value: ProfileTypeFilterValue) => void;
}

function ProfileTypeFilter(props: Props) {
  const { value, onChange } = props;

  const selectedOption = PROFILE_TYPE_FILTER_OPTIONS.find(
    (option) => option.name === value?.value
  );

  const handleChange = (option: ProfileTypeFilterOption) => {
    onChange({
      value: option.name,
    });
  };

  return (
    <SelectMenu
      label="Profile Type"
      value={selectedOption}
      items={PROFILE_TYPE_FILTER_OPTIONS}
      onChange={handleChange}
      displayValue={(item) => item?.label || ''}
      id={(item) => item.id}
    />
  );
}

export default ProfileTypeFilter;
